import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators, FormGroup } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { LoginService } from '../services/login.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  username = "";
  password = "";
  email = "";
  rx = /[\S]/g;
  public host = 'https://pwa.the-erm.com';
  errors:any = {};
  loginForm:FormGroup;
  selected = new FormControl(0);
  hide=true;

  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  matcher = new MyErrorStateMatcher();
  constructor(private http:HttpClient,
              private router:Router,
              private loginService: LoginService) { }

  ngOnInit() {
    if (this.loginService.loggedIn) {
      this.router.navigate(['/home']);
      return;
    }
    this.loginForm = new FormGroup({
        username: new FormControl(null, Validators.required),
        password: new FormControl(null, [Validators.required, Validators.minLength(6), Validators.maxLength(15), Validators.pattern('^.*(?=.{4,10})(?=.*\\d)(?=.*[a-zA-Z]).*$')]),
        email: this.emailFormControl,
    });
    if (document.location.search.indexOf("invite_code=") != -1) {
      this.selected.setValue(1);
    }
  }

  login() {
    let req = {
      "username": this.username,
      "password": this.password,
    };
    this.http.post(this.host+"/api/login.php", req).subscribe((res:any) => {
      console.log("res:", res);
      if (res.errors) {
        this.errors = res.errors;
        let fields = ['username', 'password'];
        fields.forEach((key) => {
          if (res.errors[key]) {
            this.loginForm.controls[key].setErrors({'incorrect': true});
          } else {
            this.loginForm.controls[key].setErrors(null);
          }
        });
        return;
      }
      if (res.token) {
        localStorage.token = res.token;
        this.router.navigate(['/home']);
      }

    });
  }

  create() {
    let req:any = {
      "username": this.username,
      "password": this.password,
      "email": this.email
    };
    if (document.location.search.indexOf("invite_code=") != -1) {
      let rx = /invite_code=([A-z0-9]+)/;
      let res = rx.exec(document.location.search);
      console.log("res:", res);
      if (res && res[1]) {
        req.invite_code = res[1];
      }
    }
    console.log("req:", req);
    if (!this.email || !this.password || !this.username) {
      return;
    }

    this.http.post(this.host+"/api/create.php", req).subscribe((res:any) => {
      console.log("res:", res);
      if (res.errors) {
        this.errors = res.errors;
        let fields = ['username', 'password'];
        fields.forEach((key) => {
          console.log("key:",key)
          if (res.errors[key]) {
            this.loginForm.controls[key].setErrors({'incorrect': true});
            console.error("key:", key, "value:", res[key]);
          } else {
            this.loginForm.controls[key].setErrors(null);
          }
        });
        // formData.form.controls['email'].setErrors

        // this.loginForm.controls.password.setErrors({'incorrect': true});
        console.log(this.loginForm);
        return;
      }

    });
  }

}
